import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { m } from 'framer-motion';
import XCircle from '@components/Icons/XCircle';
import { useIsMobile } from '@/hooks';
import Spacer from '@/components/Spacer';
import s from './PaneWrapper.module.scss';

type Props = {
  onClose: () => void;
};

const PaneWrapper: React.FC<Props> = ({ children, onClose }) => {
  const isMobile = useIsMobile();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const handleClose = (): void => {
    onCloseRef.current();
  };

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, []);

  return (
    <m.div
      initial={{ boxShadow: '0 0 0 4000px rgba(0, 0, 0, 0)', y: 'min(100vh, 100dvh)' }}
      animate={{ boxShadow: '0 0 0 4000px rgba(0, 0, 0, 0.3)', y: 0 }}
      exit={{ boxShadow: '0 0 0 4000px rgba(0, 0, 0, 0)', y: 'min(100vh, 100dvh)' }}
      className={s.container}
    >
      <div className={classNames(s.content, 'pane-content')}>
        {children}
        {isMobile && <Spacer size={96} />}
      </div>
      <button className={s.closeButton} onClick={handleClose}>
        <XCircle weight="fill" size={24} color="var(--color-gray-100)" />
      </button>
    </m.div>
  );
};

export default PaneWrapper;
